import UiLstStoreBase from '../../cls/stores/UiLstStoreBase'

/**
 * @class UiLstDocumentationStore
 * @extends UiLstStoreBase
 * @description This class represents the store for the UI list of notification. It extends the UiLstStoreBase class and initializes the notification store with default filters for progress, category, and deadline.
 */
class UiLstDocumentationStore extends UiLstStoreBase {
	/**
	 * @constructor
	 * @param {object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of UiLstDocumentationStore with the specified root store and initializes the store with default filters.
	 */
	constructor(rootStore) {
		// Call the parent constructor with the root store and default filters
		super(rootStore, {
			appType: ''
		})
	}
}

export default UiLstDocumentationStore
